import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';

import { useResource } from 'app/common/api';
import { usePageNotify } from 'app/common/notifications/features/page-notifications';
import { appRoute } from 'app/terminals/router/routes';
import { Loading } from 'app/ui';

import { TTerminalProfile } from '../../core/profiles';
import { addTerminalProfileRequest } from '../../requests/add-terminal-profile.request';
import { ProfileForm } from '../profile-form';

type NewTerminalProfile = Omit<TTerminalProfile, 'id' | 'employees'> & {
  employees: Pick<TTerminalProfile['employees'][number], 'id'>[];
};

export const AddProfile = observer(() => {
  const navigate = useNavigate();
  const notify = usePageNotify();

  const addProfileResource = useResource<NewTerminalProfile, TTerminalProfile>({
    request: addTerminalProfileRequest,
    errorNotify: notify,
    onDone: (result) => {
      const newProfileId = result.id;
      const newProfilePath = appRoute.PROFILE.buildPath({ id: newProfileId });

      navigate(newProfilePath);
    },
  });

  const handleSubmit = (fields: NewTerminalProfile) => {
    addProfileResource.send(fields);
  };

  return (
    <Loading active={addProfileResource.isLoading}>
      <ProfileForm onSubmit={handleSubmit} />
    </Loading>
  );
});
